/* eslint-disable */
/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */

export type CohortStageSettingDtoStage =
  (typeof CohortStageSettingDtoStage)[keyof typeof CohortStageSettingDtoStage];

export const CohortStageSettingDtoStage = {
  ADMIT: 'ADMIT',
  NET_DEPOSIT: 'NET_DEPOSIT',
} as const;
